import RichText from "./RichText";
import React from "react";

import PropTypes from "prop-types";
import SingleColumnLayout from "./SingleColumnLayout";

function HoldingPageContent({ content }) {
  return (
    <SingleColumnLayout>
      <RichText>{content}</RichText>
    </SingleColumnLayout>
  );
}

HoldingPageContent.propTypes = {
  content: PropTypes.string.isRequired,
};

export default HoldingPageContent;
